import {PurchaserReportContext} from '../context'
import useGetPurchaserReport from '../hooks/useGetPurchaserReport'
import PurchaserReportTable from '../sections/table/PurchaserReportTable'

const PurchaserReport = () => {
  const {purchaserData, isLoading, filters, searchValue, onSearch, onSortingChange} =
    useGetPurchaserReport()

  const contextValue = {
    purchaserData,
    isLoading,
    filters,
    searchValue,
    onSearch,
    onSortingChange,
  }

  return (
    <PurchaserReportContext.Provider value={contextValue}>
      <PurchaserReportTable />
    </PurchaserReportContext.Provider>
  )
}

export default PurchaserReport
